import React, { useEffect } from "react";
import useStyles from "../common/Styles";
import { Box } from "@material-ui/core";
import ChartTitle from "../common/ChartTitle";
import CitiesMap from "./CitiesMap";
import CitiesStackBar from "./CitiesStackBar";
import CitiesTreemap from "./CitiesTreemap";
import userActions from '../common/actions';
import appActions from '../../../app/actions';
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const ChartView = (props) => {
  const classes = useStyles();
  const { setWaterUserChart } = userActions();
  const { chart } = props;
  const { setChartDrawerStateToClose } = appActions();
  const { isMobile } = useGetViewPortDimensions();

  const resetWater = () => {
    return () => setWaterUserChart(0);
  }
  useEffect(resetWater, []);

  return (
    <Box className={isMobile ? classes.chartViewResponsive : classes.chartView} onClick={()=>{ setChartDrawerStateToClose() }}>
      <ChartTitle
        floating={chart.floating_title}
        title={chart.title}
        subtitle={chart.subtitle}
        background={chart.floating_title ? "#EDEDED" : "transparent"}
      />
      {
        {
          title_map: <CitiesMap />,
          community_water_use: <CitiesTreemap />,
          water_company_use: <CitiesStackBar />,
        }[chart.id]
      }
      {/* <Box mb={1} className={classes.legendContainer}>
        <Paper className={classes.legendPaper} />
      </Box> */}
    </Box>
  );
};

export default ChartView;
